export const GET_PRODUCT_CATEGORY_REQUEST="GET_PRODUCT_CATEGORY_REQUEST"
export const GET_PRODUCT_CATEGORY_SUCCESS="GET_PRODUCT_CATEGORY_SUCCESS"
export const GET_PRODUCT_CATEGORY_FAILURE="GET_PRODUCT_CATEGORY_FAILURE"